import styled from '@emotion/styled'
import { mediaQueryMobileLimit } from '../../../utils/constants';
import { Colors } from '../../../colors';
import { Grid } from '@mui/material';
export const RoomsListPageStyled = {
  ContainerPage: styled(Grid)<any>`
    width: 100%;
  `,
  Container: styled(Grid)<any>`
    display: flex;
    flex-direction: column;
    background: ${Colors.White};
    width: 100%;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      padding: 34px;
    }
  `,
  Title: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 16px;
    color: ${Colors.Black};
  `,
  SubTitle: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 12px;
    color: ${Colors.Black};
    margin-top: 5px;
  `,
};
